/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2022-01-26T10:50:44.544
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listFinancialTransferOprLog,
	listFinancialTransferOprLogInit,
	listFinancialTransferOprLogByAuthorizations,
	deleteFinancialTransferOprLog
	
} from '@api/financial/FinancialTransferOprLog';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listFinancialTransferOprLog({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialTransferOprLog(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialTransferOprLogByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialTransferOprLogByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialTransferOprLogInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialTransferOprLogInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancialTransferOprLog({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialTransferOprLog({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
